import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Box, IconButton, Typography } from "@mui/material"
import { FiltersDrawer } from "../../../../../../../../components/filtersDrawer"
import { icons } from "../../../../../../../../utils/icons"
import { CustomTable } from "../../../../../../../../components"
import { DinamicForm } from "../../../../../../../../components/dinamicForm"
import { UserListFilesProps } from "./types"





export const UserListFiles = ( { filterFileList, filterListData, columnList, rowList, tableLoading, totalPages }:UserListFilesProps) => {


    const styles = useStyles()
    const { t } = useTranslation()
    const { counter, errors, filterData, paginationModel, handlePagination, onChange, cleanFilter, sortTable, query } = filterFileList
    const { input } = filterListData

    return (
        <Box>
            <FiltersDrawer cleanFilter={cleanFilter} count={counter} right={0} top={90}>
                <Box sx={styles.section}>
                    <DinamicForm errors={errors} input={Object.values(input)} values={filterData} onChange={onChange} filter={true} legacyErrors />
                </Box>
            </FiltersDrawer>

            <Box sx={styles.header}>
                <Typography variant="title_grey_big">{t('filesManager.titles.usersWithFilesAssigned')}</Typography>

                <Box sx={styles.flex}>
                    {!!counter && <IconButton
                        sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                        onClick={() => {
                            cleanFilter()
                        }}
                    >
                        {icons('clean')}
                    </IconButton>
                    }
                   
                </Box>
            </Box>

            <CustomTable
                name="Informe General"
                serverSidePagination={{ page: paginationModel.page + 1, size: paginationModel.pageSize, totalPages: totalPages }}
                handleChange={(page: number, pageSize: number) => {
                    handlePagination({ page, pageSize })
                }}
                order={
                    query?.sort && {
                        count: query?.sort?.count,
                        key: query?.sort?.field,
                        order: query?.sort?.sort,
                    }
                }
                sortable={(field, sort, count) => {
                    sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                }}
                column={columnList}
                loader={tableLoading}
                row={rowList}
                selected={-1}
            />

        </Box>
    )
}